import React from 'react';
import { FaCheck } from 'react-icons/fa6';
import './ActivitySelectionScreen.css';

const ActivitySelectionScreen = ({ activityTypes, selectedActivities, onActivityToggle, onNext }) => {
  const MAX_SELECTIONS = 5;
  const MIN_SELECTIONS = 1;

  const handleActivityToggle = (activityTypeId) => {
    if (selectedActivities.includes(activityTypeId)) {
      // Always allow deselection - validation happens on Next button
      onActivityToggle(activityTypeId);
    } else {
      // Select - but ensure we don't exceed maximum
      if (selectedActivities.length < MAX_SELECTIONS) {
        onActivityToggle(activityTypeId);
      }
    }
  };

  const canProceed = selectedActivities.length >= MIN_SELECTIONS && selectedActivities.length <= MAX_SELECTIONS;

  // Debug: Log activity types
  console.log('🔍 ActivitySelectionScreen: Rendering with activityTypes:', {
    count: activityTypes?.length || 0,
    activityTypes: activityTypes
  });

  if (!activityTypes || activityTypes.length === 0) {
    return (
      <div className="activity-selection-screen">
        <div className="activity-selection-header">
          <h2 className="activity-selection-title">What activities are on your list this week?</h2>
          <p className="activity-selection-subtext">
            Based on the kind of tasks you need to do this week, we will organise a shortlist of prompts for you to use.
          </p>
        </div>
        <div className="activity-selection-content">
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            <p>Loading activity types...</p>
            <p style={{ fontSize: '14px', marginTop: '10px' }}>
              If this message persists, activity types may not be configured in the database.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-selection-screen">
      <div className="activity-selection-header">
        <h2 className="activity-selection-title">What activities are on your list this week?</h2>
        <p className="activity-selection-subtext">
          Based on the kind of tasks you need to do this week, we will organise a shortlist of prompts for you to use.
        </p>
      </div>

      <div className="activity-selection-content">
        <div className="activity-grid">
          <div className="activity-column">
            {activityTypes.slice(0, 4).map((bucket) => (
              <div key={bucket.contentBucket} className="activity-bucket">
                <h3 className="activity-bucket-title">{bucket.contentBucket}</h3>
                <div className="activity-list">
                  {bucket.activities.map((activity) => {
                    const isSelected = selectedActivities.includes(activity.activityTypeId);
                    const canSelect = !isSelected && selectedActivities.length < MAX_SELECTIONS;
                    const isDisabled = !canSelect && !isSelected; // Only disable if trying to select when at max

                    return (
                      <label
                        key={activity.activityTypeId}
                        className={`activity-checkbox-label ${isDisabled ? 'disabled' : ''}`}
                      >
                        <input
                          type="checkbox"
                          className="activity-checkbox"
                          checked={isSelected}
                          onChange={() => handleActivityToggle(activity.activityTypeId)}
                          disabled={isDisabled}
                        />
                        <span className="activity-checkbox-custom">
                          {isSelected && <FaCheck className="activity-check-icon" />}
                        </span>
                        <span className="activity-title">{activity.activityTitle}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
          <div className="activity-column">
            {activityTypes.slice(4, 8).map((bucket) => (
              <div key={bucket.contentBucket} className="activity-bucket">
                <h3 className="activity-bucket-title">{bucket.contentBucket}</h3>
                <div className="activity-list">
                  {bucket.activities.map((activity) => {
                    const isSelected = selectedActivities.includes(activity.activityTypeId);
                    const canSelect = !isSelected && selectedActivities.length < MAX_SELECTIONS;
                    const isDisabled = !canSelect && !isSelected; // Only disable if trying to select when at max

                    return (
                      <label
                        key={activity.activityTypeId}
                        className={`activity-checkbox-label ${isDisabled ? 'disabled' : ''}`}
                      >
                        <input
                          type="checkbox"
                          className="activity-checkbox"
                          checked={isSelected}
                          onChange={() => handleActivityToggle(activity.activityTypeId)}
                          disabled={isDisabled}
                        />
                        <span className="activity-checkbox-custom">
                          {isSelected && <FaCheck className="activity-check-icon" />}
                        </span>
                        <span className="activity-title">{activity.activityTitle}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="activity-selection-footer">
        <div className="selection-count">
          {selectedActivities.length} of {MAX_SELECTIONS} selected
        </div>
        <button
          className="activity-next-button"
          onClick={onNext}
          disabled={!canProceed}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ActivitySelectionScreen;

